module.exports = __webpack_public_path__ + "img/samandehi.2eb588c4.png";